module.exports = __webpack_public_path__ + "static/media/diningYoho.eeee27fe.jpg";